module.exports = __webpack_public_path__ + "img/lift.b73116a4.jpg";